var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tituloDiasSemana",style:(_vm.labelDayStyle)},[_c('span',[_vm._v(_vm._s(_vm.options.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }